export const SalarySlipData =
{
    Name             : 'Murat',
    Designation      : 'System Engineer',
    Total_No_of_Days : '31',
    Gender           : 'Male',
    Employee_Code    : 'H-367',
    Department       : 'Software',
    ICICI_AC         : '12345658',
    PF_AC_No         : ' NGNAG00650030000012345',
    ESI_No           : '1234565',
    Earning : [
            {
                component : 'Basic',
                value : 2032
            }
        ,
         
            {
                component : 'HRA',
                value : 813
            }
        ,
         
            {
                component : 'Conveyance',
                value : 155
            }
        ,
         
            {
                component : 'Medical',
                value : 121
            }
        ,
         
            {
                component : 'Skills Development Allowance',
                value : 611
            }
        ,
         
            {
                component : 'Communication Allowance',
                value : 53
            }
        ,
    ],
    Deduction : [
        
            {
                component : 'Profession Tax',
                value : 0
            }
        ,
        
            {
                component : 'Provident Fund',
                value : 454
            }
        ,
    ]
}